import moment from "moment";
import { ISlot } from "../pages/scheduleSession/BookExamSlot";

function prepareSlots(slots: ISlot[]) {
  let _datesAndSlots: any = {};
  slots.forEach((slot: ISlot) => {
    const date = moment.unix(slot.time).format("DD/MM/YYYY");
    const time = moment.unix(slot.time).format("hh:mm A");

    if (!_datesAndSlots[date]) {
      _datesAndSlots[date] = [];
    }
    _datesAndSlots[date].push({ time, slot: slot.time });
  });
  return _datesAndSlots;
}

export default prepareSlots;
